<template>
  <span>
    <b-row style="margin-top: 40px; margin-left: 1%; margin-right: 1%">
      <b-col col lg="5" md="10" sm="10">
        <b-card>
          <h6 class="text-center">Pay Arrears</h6>
          <br />

          <div class="form-group mb-3 input-group input-text-wrapper">
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color: #ffffff; border: none"
              >
                <font-awesome-icon
                  icon="sort-numeric-down"
                  style="color: #ced4da"
                />
              </span>
            </div>

            <span style="border-right: #ced4da 1px solid">
              <b-form-input
                v-model="form.box_number"
                class="box-text-input"
                placeholder="Box Number"
                required
                type="number"
              >
              </b-form-input>
            </span>

            <b-form-select
              class="box-text-input"
              v-model="form.station_id"
              required
            >
              <b-select-option :value="null">Choose Station</b-select-option>
              <b-select-option
                v-for="branch in getPostOffices"
                :key="branch"
                :value="branch.branch_id"
              >
                {{ branch.name }}
              </b-select-option>
            </b-form-select>
          </div>

          <br />
          <button
            v-if="!dataLoaded"
            class="form-control signUpButtonCard button"
            style="margin-bottom: 4%"
            @click="check_arrears"
          >
            Check arrears
            <b-spinner
              v-if="payArrearsSpinner"
              label="Loading..."
              small
            ></b-spinner>
          </button>

          <div
            v-if="dataLoaded"
            class="form-group mb-3 input-group input-text-wrapper"
          >
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color: #ffffff; border: none"
              >
                <font-awesome-icon icon="money-bill" style="color: #ced4da" />
              </span>
            </div>
            <b-form-input
              class="box-text-input"
              v-model="form.amount"
              type="number"
              required
              placeholder="Amount"
            ></b-form-input>
          </div>

          <br />

          <button
            v-if="dataLoaded"
            class="form-control signUpButtonCard button"
            style="margin-bottom: 4%"
          >
            Pay
            <b-spinner
              v-if="payArrearsSpinner"
              label="Loading..."
              small
            ></b-spinner>
          </button>
        </b-card>
      </b-col>
    </b-row>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "PayArrears",
  data() {
    return {
      payArrearsSpinner: false,
      form: {
        box_number: null,
        station_id: null,
        duration_id: null,
      },
      dataLoaded: false,
      amount: 0,
      boxData: {},

      duration: [
        { value: null, text: "Select Duration" },
        { value: "4years", text: "4 Years - 4000" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getBoxArrearsData",
      "getErrorsMessageArrears",
      "getPostOffices",
    ]),
    arrears_due() {
      return this.getBoxArrearsData;
    },
  },
  methods: {
    ...mapActions(["calculateArrears", "fetchPostOffices", "doPayArrears"]),

    check_arrears() {
      let data = {
        station: this.form.station_id,
        box_number: this.form.box_number,
      };

      this.calculateArrears(data);
    },
    do_pay() {
      /*let data = {
        station: this.boxData.renter.b_station,
      };*/
    },
  },
  watch: {
    arrears_due(data) {
      this.dataLoaded = true;
      this.amount = data.amount;
      this.boxData = data;
    },
  },
  mounted() {
    this.fetchPostOffices();
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.delivery {
  width: 100%;
}

.action {
  margin-top: 30px;
  margin-left: 20px;
}

.button {
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.button:hover {
  background: #9f0012;
}

.input {
  width: 100%;
  margin-bottom: 10px;
}

.form {
  width: 100%;
  margin: 15px;
}

.results {
  width: 90%;
  margin-top: 10px;
  margin-left: 20px;
}

.key-label {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 14px;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.status {
  font-size: 14px;
  background: #0a7027;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  margin-left: 1px;
  font-weight: bold;
  text-align: center;
}
</style>
